import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

const BackToSignInButton = ({
  changeState
}) => (
  <Button
    variant="raised"
    fullWidth={true}
    className="auth__back"
    onClick={() => changeState('signIn')}
  >
    Back To Sign In
  </Button>
);

BackToSignInButton.propTypes = {
  changeState: PropTypes.func.isRequired,
};

export default BackToSignInButton;



// WEBPACK FOOTER //
// ./src/components/Authentication/components/BackToSignInButton.js